"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Captcha = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactGoogleRecaptcha = _interopRequireDefault(require("react-google-recaptcha"));
var Captcha = exports.Captcha = function Captcha(_ref) {
  var onChange = _ref.onChange,
    siteKey = _ref.siteKey;
  return _react["default"].createElement("div", {
    style: {
      margin: 'auto',
      width: 304
    }
  }, _react["default"].createElement(_reactGoogleRecaptcha["default"], {
    sitekey: siteKey,
    onChange: onChange
  }));
};
Captcha.propTypes = {
  onChange: _propTypes["default"].func,
  siteKey: _propTypes["default"].string
};